// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__PNeSo","skeleton-loading":"skeleton_skeleton-loading__-TyjQ","skeleton__circle":"skeleton_skeleton__circle__mMgmM"};